import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => (
    <>
        <path
            d="M17.4162 12.833C18.782 11.4947 20.1662 9.89061 20.1662 7.79149C20.1662 6.45439 19.635 5.17205 18.6895 4.22658C17.7441 3.2811 16.4617 2.74994 15.1246 2.74994C13.5113 2.74994 12.3747 3.20826 10.9997 4.58323C9.62474 3.20826 8.4881 2.74994 6.8748 2.74994C5.5377 2.74994 4.25536 3.2811 3.30989 4.22658C2.36441 5.17205 1.83325 6.45439 1.83325 7.79149C1.83325 9.89977 3.20822 11.5039 4.58319 12.833L10.9997 19.2496L17.4162 12.833Z"
            stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M2.95154 10.9997H8.70807L9.16639 10.0831L10.9997 14.208L12.833 7.79147L14.2079 10.9997H19.0387"
              stroke={color} strokeWidth="1.64996" strokeLinecap="round" strokeLinejoin="round"/>
    </>
)

export const HeartIcon: React.FC<IconProps> = ({color, size = 22}) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{size, color, renderIcon}} />
)
